import * as yup from 'yup';

import { StringTypeBase } from '../../baseTypes/StringTypeBase';
import { FlexJustifyContentEnum } from '../../blocks/Flex';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';

export class FlexJustifyContentType extends StringTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'FlexJustifyContent';

  friendlyName = 'Main-axis alignment.';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  superUserOnly = false;

  get example() {
    return FlexJustifyContentEnum.Center;
  }

  get default(): any {
    return FlexJustifyContentEnum.Center;
  }

  buildSchema() {
    return yup.string().nullable().oneOf(Object.values(FlexJustifyContentEnum));
  }
}

const definition = new FlexJustifyContentType();

Types.addBaseType(definition);

export { definition as FlexJustifyContentDefinition };
